import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const Blog = () => {
  const blogPosts = [
    {
      id: 'cheaper-home-batteries-scheme',
      title: 'Cheaper Home Batteries Scheme NSW: Complete Guide 2024-2025',
      excerpt: 'Everything you need to know about the federal Cheaper Home Batteries scheme in NSW. Eligibility, application process, and how to save thousands on battery storage.',
      image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVsc3xlbnwwfHx8fDE3NjEyNTE3NzV8MA&ixlib=rb-4.1.0&q=85',
      date: 'December 2024',
      category: 'Government Incentives'
    },
    {
      id: 'sigenergy-battery-review',
      title: 'Sigenergy Battery System Review: 97% DoD & Modular Design',
      excerpt: 'Complete technical review of Sigenergy home battery systems. 5-48kWh capacity, 97% depth of discharge, and why it\'s a top choice for Australian homes.',
      image: 'https://customer-assets.emergentagent.com/job_solarpanel-site-1/artifacts/cgw4ykwm_Sigenergy.jpg',
      date: 'December 2024',
      category: 'Battery Reviews'
    },
    {
      id: 'fox-ess-eq4800-review',
      title: 'Fox ESS EQ4800 Battery Review: 100% DoD & 4.66kWh Modules',
      excerpt: 'Detailed Fox ESS EQ4800 battery review. 100% depth of discharge, modular 4.66kWh design, technical specs, and installation benefits for Sydney homes.',
      image: 'https://customer-assets.emergentagent.com/job_solarpanel-site-1/artifacts/xddsnnsu_Fox%20ess%20EQ%204800.png',
      date: 'December 2024',
      category: 'Battery Reviews'
    },
    {
      id: 'goodwe-lynx-battery-review',
      title: 'Goodwe Lynx Home U Battery: 100% DoD & 5.4-32.4kWh Capacity',
      excerpt: 'Comprehensive Goodwe Lynx Home U battery review. 100% depth of discharge, scalable capacity, technical specifications, and pricing for NSW installations.',
      image: 'https://customer-assets.emergentagent.com/job_solarpanel-site-1/artifacts/kinfcwcg_goodwe.png',
      date: 'December 2024',
      category: 'Battery Reviews'
    },
    {
      id: 'sungrow-sbr-battery-review',
      title: 'Sungrow SBR Battery Review: 100% DoD Modular Storage',
      excerpt: 'In-depth Sungrow SBR battery system review. 100% depth of discharge, 3.2kWh modular design, expandable capacity, and Australian warranty coverage.',
      image: 'https://customer-assets.emergentagent.com/job_solarpanel-site-1/artifacts/ahe8ea2o_Sungrow%20SBR.jpeg',
      date: 'December 2024',
      category: 'Battery Reviews'
    },
    {
      id: 'sungrow-sbh-battery-review',
      title: 'Sungrow SBH Battery Review: High Capacity Hybrid Storage',
      excerpt: 'Complete Sungrow SBH battery review. High-capacity hybrid storage solution, advanced BMS, seamless solar integration, and performance data for Sydney installations.',
      image: 'https://customer-assets.emergentagent.com/job_solarpanel-site-1/artifacts/momm4ffi_sungrow%20SBH.png',
      date: 'December 2024',
      category: 'Battery Reviews'
    },
    {
      id: 'goodwe-esa-allinone',
      title: 'Goodwe ESA All-in-One System: Complete Solar & Storage Solution',
      excerpt: 'Discover Goodwe ESA All-in-One integrated solar and battery system. Single-unit convenience, advanced features, cost-effective solution for Australian homes.',
      image: 'https://customer-assets.emergentagent.com/job_solarpanel-site-1/artifacts/kinfcwcg_goodwe.png',
      date: 'January 2025',
      category: 'Solar Systems'
    },
    {
      id: 'fox-ess-cq6-battery',
      title: 'Fox ESS CQ6 Battery: Premium Features & Value for Money',
      excerpt: 'Fox ESS CQ6 battery system features and value analysis. High-capacity storage, advanced technology, competitive pricing for Sydney solar installations.',
      image: 'https://customer-assets.emergentagent.com/job_solarpanel-site-1/artifacts/xddsnnsu_Fox%20ess%20EQ%204800.png',
      date: 'January 2025',
      category: 'Battery Systems'
    }
  ];

  return (
    <>
      <SEO 
        title="Solar & Battery Blog Sydney | Expert Reviews & Installation Guides"
        description="Expert solar and battery insights from Energy Spectrum. Sigenergy, Fox ESS CQ6, Goodwe ESA All-in-One, Sungrow reviews. Solar installation tips for Sydney NSW."
        keywords="solar battery reviews Sydney, Goodwe ESA, Fox ESS CQ6, all-in-one solar system, battery storage guide, solar blog Sydney"
      />
      <div className="blog-container">
        {/* Hero Section */}
        <section className="page-hero">
        <div className="container">
          <h1 className="display-medium">Solar & Battery Insights</h1>
          <p className="body-large page-hero-description">
            Expert advice, technical reviews, and the latest updates on solar energy and battery storage
          </p>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="blog-grid-section">
        <div className="container">
          <div className="blog-grid">
            {blogPosts.map((post) => (
              <Card key={post.id} className="blog-card">
                <Link to={`/blog/${post.id}`} className="blog-card-link">
                  <div className="blog-card-image">
                    <img src={post.image} alt={`${post.title} - Expert review by Energy Spectrum Sydney`} />
                    <div className="blog-card-category">{post.category}</div>
                  </div>
                  <div className="blog-card-content">
                    <div className="blog-card-meta">
                      <Calendar size={16} />
                      <span>{post.date}</span>
                    </div>
                    <h2 className="heading-3">{post.title}</h2>
                    <p className="body-medium blog-card-excerpt">{post.excerpt}</p>
                    <div className="blog-card-read-more">
                      <span>Read More</span>
                      <ArrowRight size={20} />
                    </div>
                  </div>
                </Link>
              </Card>
            ))}
          </div>
        </div>
      </section>
      </div>
    </>
  );
};

export default Blog;